import { DataTestIds } from '@repo/frontend-shared';
import { SDSIcon } from '@repo/sds/SDSIcon';
import { SDSIconButton } from '@repo/sds/SDSIconButton';
import { SDSPrimitiveButton } from '@repo/sds/SDSPrimitiveButton';
import { SDSText, type SDSTextType } from '@repo/sds/SDSText';
import { AngleDownIcon } from '@repo/ui/assets/icons/AngleDownIcon';
import { CalendarLeftIcon } from '@repo/ui/assets/icons/CalendarLeftIcon';
import { CalendarRightIcon } from '@repo/ui/assets/icons/CalendarRightIcon';
import { usePeriodCalendar } from '@repo/ui/fixtures/smallCalendar/hooks/use-calendar';

import './CalendarMonthAndYearPicker.scss';

interface CalendarMonthAndYearPickerProps {
  onClick?: () => void;
  labelType?: SDSTextType;
}

export function CalendarMonthAndYearPicker({ onClick, labelType = 'body-medium' }: CalendarMonthAndYearPickerProps) {
  const { periodLabel, goToNextPeriod, goToPreviousPeriod } = usePeriodCalendar();

  return (
    <div className="CalendarMonthAndYearPicker">
      <SDSIconButton
        className="CalendarMonthAndYearPicker__icon"
        icon={<CalendarLeftIcon />}
        onClick={goToPreviousPeriod}
        ariaLabel="Go to previous period"
        size="medium"
        dataTestId={DataTestIds.COMMON.CALENDAR_PREV_PERIOD}
      />
      {onClick == null ? (
        <div className="CalendarMonthAndYearPicker__center-container">
          <SDSText type={labelType} text={periodLabel} dataTestId={DataTestIds.COMMON.CALENDAR_PERIOD_LABEL} />
        </div>
      ) : (
        <SDSPrimitiveButton className="CalendarMonthAndYearPicker__center-container" onClick={onClick}>
          <SDSText type={labelType} text={periodLabel} dataTestId={DataTestIds.COMMON.CALENDAR_PERIOD_LABEL} />
          <SDSIcon className="CalendarMonthAndYearPicker__down-icon" icon={<AngleDownIcon />} size="small" />
        </SDSPrimitiveButton>
      )}
      <SDSIconButton
        className="CalendarMonthAndYearPicker__icon"
        icon={<CalendarRightIcon />}
        onClick={goToNextPeriod}
        ariaLabel="Go to next period"
        size="medium"
        dataTestId={DataTestIds.COMMON.CALENDAR_NEXT_PERIOD}
      />
    </div>
  );
}
